<template>
  <div class="cart noprint-top">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Cart",
  components: {},
};
</script>

<style scoped lang="scss">
@media print {
  .cart.noprint-top {
    padding-top: 0;
  }
}

.cart {
  padding-top: 80px;
}
</style>
